import clsx from 'clsx'
import { useEffect, useState } from 'react'

import { ReactComponent as ChevronIcon } from 'assets/icons/chevron.svg'
export interface AccordionHeaderProps {
  title: string
  expanded?: boolean
  onClick?: () => void
}

export const AccordionHeader = ({ title, expanded, onClick }: AccordionHeaderProps) => {
  const [isExpanded, setIsExpanded] = useState(expanded)

  useEffect(() => {
    setIsExpanded(expanded)
  }, [expanded])

  const handleAccordionItemClick = () => {
    setIsExpanded(!isExpanded)
    onClick && onClick()
  }

  return (
    <div
      slot="header"
      className={clsx('flex items-center cursor-pointer w-[784px] py-4', !isExpanded && 'pb-4')}
      onClick={handleAccordionItemClick}
    >
      <h2 className="text-16 leading-6 font-bold tracking-0 grow text-wrap">{title}</h2>

      <ChevronIcon className={clsx('ease-in-out transition-transform shrink-0', isExpanded && 'rotate-180')} />
    </div>
  )
}
